import { render, staticRenderFns } from "./_base-simple-table.vue?vue&type=template&id=4111daa8&scoped=true&"
import script from "./_base-simple-table.vue?vue&type=script&lang=js&"
export * from "./_base-simple-table.vue?vue&type=script&lang=js&"
import style0 from "./_base-simple-table.vue?vue&type=style&index=0&id=4111daa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4111daa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
